import React, {forwardRef, useCallback} from "react";
import {TextField} from "@mui/material";
import InputMask from "react-input-mask";
import {MuiRFF} from '../../form';

/**
 * @param {formApi} form
 * @param {function(val?: string)} onChange
 * @param {any} value
 * @param {string?} name
 * @param {string?} type
 * @param {Partial<import("@mui/material").TextFieldProps> & Partial<import("mui-rff").TextFieldProps>} props
 */
const PhoneInput = forwardRef(({
                                   form = null,
                                   onChange,
                                   value,
                                   name,
                                   type = 'tel',
                                   ...props
                               }, ref) => {

    /**
     * Custom error function that only shows error when form has been submitted and not changed
     */
    const customShowErrorFunction = useCallback(({meta: {error, submitFailed}}) => {
        return (submitFailed && error);
    }, [])

    /**
     * Formats the value of the phone input.
     */
    const formatValue = useCallback((val) => {
        return (val?.trim() ?? '')
            .replace(/[()_-]/g, '')
            .replace(/\+1/g, '')
            .replaceAll(' ', '')
    }, [])

    /**
     * Invokes the appropriate method/callback to indicate a change of the input value.
     * @param {ChangeEvent<HTMLInputElement>} e
     */
    const onValueChanged = useCallback((e) => {
        if (form) {
            form?.change(e.target.name, e.target.value)
        } else {
            onChange && onChange(e.target.value);
        }
    }, [form, onChange])

    return (
        <>
            <InputMask
                mask={"+\\1 (999) 999-9999"}
                value={value}
                onChange={onValueChanged}
                maskChar={'_'}
                {...props}
            >
                {(inputProps) =>
                    (form)
                        ?
                        <MuiRFF.TextField
                            name={name}
                            variant={'outlined'}
                            showError={customShowErrorFunction}
                            fieldProps={{formatOnBlur: true, format: formatValue}}
                            {...inputProps}
                            ref={ref}
                            type={type}
                        />
                        : <TextField
                            variant={'outlined'}
                            value={value}
                            {...inputProps}
                            type={type}
                            ref={ref}
                        />
                }
            </InputMask>
        </>
    )
})

export default PhoneInput;
